import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';

import xtend from 'xtend';
var noop = function () {};

import Overlay from '../../common/components/Overlay';

import categories from './categories/CategoryListing'
import keywords from './keywords/KeywordListing'
import locations from './locations/LocationListing'
import technicians from './technicians/TechnicianListing'
import encoders from './encoders/EncoderListing'

const childViews = {
    categories,
    keywords,
    locations,
    technicians,
    encoders
};

var DomainController = createReactClass({
    propTypes: {
        actions: pt.shape({
            get: pt.func.isRequired,
            delete: pt.func.isRequired
        }).isRequired,
        store: pt.func.isRequired
    },

    getInitialState: function () {
        return {
            store: this.props.store(),
            overlay: false
        };
    },

    componentWillMount: function () {
        var self = this;

        this.removeListener = this.props.store(function onChange (state) {
            self.setState({ store: state });
        });

        this.props.actions.get(function (err) {
            if (err) {
                self.props.emitSnack({
                    type: 'error',
                    message: err.message
                });
            }
        });
    },

    componentDidUpdate: function (prevProps, prevState) {
        var err = this.state.store.lastError;
        if (err) {
            var msg = err[0] ? err[0].message : err.message;
            this.props.emitSnack({
                type: 'error',
                message: msg
            });
        }
    },

    overlayHook: function (action, opts, cb) {
        if (typeof opts === 'function') {
            cb = opts;
            opts = {};
        }
        opts = opts || {};
        cb = cb || noop;

        var self = this;
        this.setState({ overlay: true });
        this.props.actions[action](opts, function onResp () {
            self.setState({ overlay: false });
            try {
                cb.apply(null, arguments);
            } catch (e) {
                console.warn(e);
            }
        });
    },

    render: function () {
        var sharedProps = {
            mode: "manage",
            data: this.state.store.data,
            isResolving: this.state.store.isResolving,
            actions: this.props.actions
        };

        if (this.props.domainName == 'categories') {
            sharedProps.nested = this.state.store.nested;
        }

        var View = childViews[this.props.domainName];

        // overlay
        var actions = xtend(this.props.actions, {
            delete: this.overlayHook.bind(this, 'delete')
        });

        return (<div className="metadata-container">
            <Overlay active={this.state.overlay} />
            <View {...this.props} {...sharedProps} actions={actions} />
        </div>);
    }
});

export default DomainController;
